import { Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import { useFormContext } from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";
import { customValidation, validations } from "../../commonFunctions/CommonFunctions";
import WSDateField from "../../Components/DateField/WSDateField";

export const OtherDetails: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <Grid container spacing={2}>
     <Grid item xs={12} sm={2}>
        <Typography>Company</Typography>
     </Grid>
     <Grid item xs={12} sm={4}>
     <WSTextField
            label={""}
            {...register("zip")}
            id="zip"
            name="zip"
            control={control}
            rules={{ required: true }}
          />
     </Grid>
     <Grid item xs={12} sm={2}>
        <Typography>Remark</Typography>
     </Grid>
     <Grid item xs={12} sm={4}>
     <WSTextField
            label={""}
            {...register("zip")}
            id="zip"
            name="zip"
            control={control}
            rules={{ required: true }}
          />
     </Grid>
     <Grid item xs={12} sm={2}>
        <Typography>Email</Typography>
     </Grid>
     <Grid item xs={12} sm={4}>
     <WSTextField
            control={control}
            id="email"
            {...register("email")}
            type={TextType.Text}
            rules={customValidation(true, validations.email)}
            name="email"
            label=" "
          />
     </Grid>
     <Grid item xs={12} sm={2}>
        <Typography>Reg. No.</Typography>
     </Grid>
     <Grid item xs={12} sm={2}>
     <WSTextField
            label={""}
            {...register("regno")}
            id="regno"
            name="regno"
            control={control}
            rules={{ required: true }}
          />
     </Grid>
     <Grid item xs={12} sm={2}>
     <WSSCheckBoxField
                        id="takeorder"
                        {...register('takeorder')}
                        label="Don't take order"
                        control={control}
                        rules={{ required: true }}
                        defaultValue={false}
                    />
     </Grid>
     <Grid item xs={12} sm={2}>
        <Typography>Birth Date</Typography>
     </Grid>
     <Grid item xs={12} sm={3}>
     <WSDateField
                id="birthdate"
                name="birthdate"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
     </Grid>
     <Grid item xs={12} sm={1}>
     <WSTextField
            label={""}
            {...register("age")}
            id="age"
            name="age"
            control={control}
            rules={{ required: true }}
          />
     </Grid>
     <Grid item xs={12} sm={1}>
        <Typography>[Age]</Typography>
     </Grid>
     <Grid item xs={12} sm={1}>
        <Typography>Anniversary</Typography>
     </Grid>
     <Grid item xs={12} sm={4}>
     <WSDateField
                id="anniversarydate"
                name="anniversarydate"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
     </Grid>
    </Grid>
  );
});
